var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "adminLayoutBox" }, [
    _c("div", { staticClass: "adminLayout_1" }, [
      _c(
        "div",
        {
          staticClass: "adminLayout_1_statistics",
          attrs: { "data-title": "统计" }
        },
        [
          _c(
            "div",
            [
              _c("m-statistics", {
                attrs: { "statistics-data": _vm.statisticsData }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "adminLayout_1_user", attrs: { "data-title": "" } },
        [
          _c("m-title", {
            attrs: {
              "title-text": "新增注册用户",
              "tip-text": "如所选时间范围内无新增用户，则不显示"
            }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "content-box" }, [
            _c("div", { staticClass: "top" }, [
              _c(
                "div",
                { staticClass: "month-select" },
                [
                  _c("m-slide-switch", {
                    attrs: { "hidden-status": _vm.hiddenTimeSwitch },
                    on: { change: _vm.monthChange }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "m-time-select" },
                [
                  _c("el-date-picker", {
                    staticStyle: { height: "90%" },
                    attrs: {
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期"
                    },
                    on: { change: _vm.registerUserTimeChange },
                    model: {
                      value: _vm.dates,
                      callback: function($$v) {
                        _vm.dates = $$v
                      },
                      expression: "dates"
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "time-mask" }, [
                    !_vm.dates.length
                      ? _c("div", [_vm._v("请选择时间段范围")])
                      : _c("div", [
                          _vm._v(
                            _vm._s(_vm.getDate(_vm.dates[0])) +
                              "至" +
                              _vm._s(_vm.getDate(_vm.dates[1]))
                          )
                        ]),
                    _vm._v(" "),
                    _c("i", { staticClass: "el-icon-date" })
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "bottom" },
              [
                _c("m-chart", {
                  attrs: {
                    "option-data": _vm.newRegisteredUserLineData,
                    showTip3: true
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "adminLayout_2", attrs: { "data-title": "" } },
      [
        _c("m-selects", {
          attrs: { size: "medium", "show-teacher-select": true },
          on: {
            change: _vm.selectChange,
            courseChange: function() {
              return _vm.courseTabChange(1)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "adminLayout_3", attrs: { "data-title": "" } },
      [
        _c("m-title", {
          attrs: { "title-text": "专业人数", "tip-text": _vm.tipText }
        }),
        _vm._v(" "),
        _c("m-course-tab", {
          attrs: { "current-type": _vm.courseType },
          on: {
            change: function(type) {
              return _vm.courseTabChange(type, true)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { flex: "1", width: "100%" } },
          [
            _c("m-chart", {
              attrs: { "option-data": _vm.numberOfProfessionalsBarData }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "adminLayout_4",
        attrs: { "data-title": "当前课程人数排行" }
      },
      [
        _c("m-ranking-list", {
          staticStyle: { "margin-top": "50px" },
          attrs: {
            "min-titles": _vm.numberOfProfessionalsTitles,
            headers: _vm.numberOfProfessionalsHeaders,
            "ranking-list": _vm.numberOfProfessionalList,
            total: _vm.numberOfProfessionalList.total,
            loading: _vm.numberOfProfessionalList.loading
          },
          on: {
            pageChange: function(pageNum) {
              return _vm.numberOfProfessionalChange(
                _vm.numberOfProfessionalIndex,
                pageNum
              )
            }
          },
          scopedSlots: _vm._u([
            {
              key: "tabHeader",
              fn: function(headers) {
                return _vm._l(headers.data, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      on: {
                        click: function($event) {
                          return _vm.numberOfProfessionalChange(index)
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.name) + "\n        ")]
                  )
                })
              }
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "adminLayout_5", attrs: { "data-title": "" } },
      [
        _c("m-title", {
          attrs: {
            "title-text": "学习时长",
            "tip-text": _vm.tipText + "，显示从当前时间往前一周或一个月的数据"
          }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "learningDuration" },
          [
            _c("m-chart", {
              attrs: {
                "option-data": _vm.learningDurationBrokenLineData,
                "tip-style": _vm.tipStyle
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "timeSwitchBox" },
          [_c("m-switch", { on: { change: _vm.timeSwitchChange } })],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "adminLayout_6", attrs: { "data-title": "" } },
      [
        _c("m-title", {
          attrs: {
            "title-text": "学时排行",
            "tip-text":
              "该模块统计数字课程、实践教学的学习时长及讨论笔记等教学工具的使用时长"
          }
        }),
        _vm._v(" "),
        _c("m-ranking-list", {
          staticStyle: { "margin-top": "30px" },
          attrs: {
            "min-titles": {
              column3Name: _vm.learningDurationIndex
                ? "学习时长"
                : "平均学习时长",
              column2Name: _vm.learningDurationIndex ? "学员" : "班级"
            },
            headers: _vm.learningDurationHeaders,
            "ranking-list": _vm.learningDurationList,
            total: _vm.learningDurationList.total,
            loading: _vm.learningDurationList.loading,
            "is-date": true
          },
          on: {
            pageChange: function(pageNum) {
              return _vm.learningDurationChange(
                _vm.learningDurationIndex,
                pageNum
              )
            }
          },
          scopedSlots: _vm._u([
            {
              key: "tabHeader",
              fn: function(headers) {
                return _vm._l(headers.data, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      on: {
                        click: function($event) {
                          return _vm.learningDurationChange(index)
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.name) + "\n        ")]
                  )
                })
              }
            }
          ])
        })
      ],
      1
    ),
    _vm._v(" "),
    false
      ? _c("div", { staticClass: "adminLayout_7" }, [
          _c("div", { attrs: { "data-title": "课程进度" } }, [
            _c(
              "div",
              [
                _c("m-chart", {
                  attrs: { "option-data": _vm.courseProgressPieData }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "progress-content" }, [
                  _vm._v(_vm._s(_vm.classProgress[0]) + "%")
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { "data-title": "课程实践练习进度" } }, [
            _c(
              "div",
              [
                _c("m-chart", {
                  attrs: { "option-data": _vm.coursePracticePieData }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "progress-content" }, [
                  _vm._v(_vm._s(_vm.classProgress[1]) + "%")
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { attrs: { "data-title": "实践教学进度" } }, [
            _c(
              "div",
              [
                _c("m-chart", {
                  attrs: { "option-data": _vm.practicalTeachingPieData }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "progress-content" }, [
                  _vm._v(_vm._s(_vm.classProgress[2]) + "%")
                ])
              ],
              1
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    false
      ? _c(
          "div",
          {
            staticClass: "adminLayout_8",
            attrs: { "data-title": "学习进度排行" }
          },
          [
            _c("m-ranking-list", {
              staticStyle: { "margin-top": "30px" },
              attrs: {
                "min-titles": { column3Name: "进度" },
                headers: _vm.rateOfLearningHeaders,
                "ranking-list": _vm.classProgressList,
                total: _vm.classProgressList.total
              },
              on: {
                pageChange: function(pageNum) {
                  return _vm.classProgressChange(
                    _vm.classProgressIndex,
                    pageNum
                  )
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "tabHeader",
                    fn: function(headers) {
                      return _vm._l(headers.data, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            on: {
                              click: function($event) {
                                return _vm.classProgressChange(index)
                              }
                            }
                          },
                          [_vm._v(_vm._s(item.name) + "\n        ")]
                        )
                      })
                    }
                  }
                ],
                null,
                false,
                1973246403
              )
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "adminLayout_9", attrs: { "data-title": "测验进度" } },
      [
        _c("m-line-progress", {
          staticStyle: { "margin-bottom": "50px" },
          attrs: { progress: _vm.testProgress, progressClass: "yellow" }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cProgressBox" },
          [_c("m-circular-progress", { attrs: { score: _vm.testScore } })],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "adminLayout_10", attrs: { "data-title": "" } },
      [
        _c("m-title", {
          attrs: { "title-text": "测验分数", "tip-text": _vm.testTipText }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "testScore" },
          [
            _c("m-chart", {
              attrs: { "option-data": _vm.testScoreBrokenLineData }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1be06805", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1be06805","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_account_settings/accountSettings/overallStatistics/layout/adminLayout.vue
// module id = null
// module chunks = 